import React from 'react'
import PropTypes from 'prop-types'
import {Tag, TagLabel, TagLeftIcon} from '@chakra-ui/react'
import {Trans, useTranslation} from 'react-i18next'

import {SolidWarningIcon, AttentionIcon} from '../../../icons'

const InvoiceStatusLabel = ({status, daysPastDue}) => {
  const {t} = useTranslation('payerStatements')

  if (status === 'due' && daysPastDue <= 0) {
    return (
      <Tag variant="status" colorScheme="warning">
        <TagLeftIcon as={SolidWarningIcon} color="mld.warning.700" />
        <TagLabel>{t('invoices.statusLabels.dueThisMonth')}</TagLabel>
      </Tag>
    )
  }

  if (status === 'overdue' || daysPastDue > 0) {
    return (
      <>
        <Tag variant="status" colorScheme="alert">
          <TagLeftIcon as={AttentionIcon} color="mld.error.700" />
          <TagLabel>{t('invoices.statusLabels.overdue')}</TagLabel>
        </Tag>
        <Tag variant="detail" colorScheme="alert">
          <TagLabel>
            <Trans
              t={t}
              values={{daysPastDue}}
              i18nKey="invoices.statusLabels.daysPastDue"
            />
          </TagLabel>
        </Tag>
      </>
    )
  }

  return (
    <Tag variant="status">
      <TagLabel>{t('invoices.statusLabels.notYetDue')}</TagLabel>
    </Tag>
  )
}

InvoiceStatusLabel.propTypes = {
  status: PropTypes.string.isRequired,
  daysPastDue: PropTypes.number.isRequired,
}

export default InvoiceStatusLabel
